import { FC } from 'react';
import { Banner, Novelties } from '@bpba/modules-components';
import { GenericComponentProps } from '@bpba/modules-components';
import { AnchorModel, Box } from '@bpba/ui-components';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { Bar } from './Bar';
import {
  NOVELTIES_BARRA_ENLACE,
  NOVELTIES_BARRA_FIN,
  NOVELTIES_BARRA_INICIO,
  NOVELTIES_BARRA_MENSAJE1,
  NOVELTIES_BARRA_MENSAJE2,
} from '../../constants/data';

export const NoveltiesWrapper: FC<GenericComponentProps<Banner>> = (props) => {
  const { isLoggedin } = useUserStatus();
  const currencyBar = getBar();

  return (
    <Box paddingTop={['0px', null, null, isLoggedin ? '40px' : 0]}>
      <Novelties {...props} currencyBar={currencyBar} />
    </Box>
  );
};

function getBar() {
  const startDate = new Date(NOVELTIES_BARRA_INICIO);
  const endDate = new Date(NOVELTIES_BARRA_FIN);
  const currentDate = new Date();

  if ((!NOVELTIES_BARRA_MENSAJE1 && !NOVELTIES_BARRA_MENSAJE2) || currentDate < startDate || currentDate > endDate) return undefined;

  const link = AnchorModel.fromJsonObject(NOVELTIES_BARRA_ENLACE);

  return <Bar texto1={NOVELTIES_BARRA_MENSAJE1} texto2={NOVELTIES_BARRA_MENSAJE2} enlace={link} />;
}
